import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const Customer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 상담문의`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });

    // IP 체크 함수
    const checkIP = async () => {
      const response = await fetch("/check-ip");
      const result = await response.json();

      // 리다이렉션 확인
      if (result.redirect) {
        navigate(result.redirect); // navigate로 리다이렉션
      }
    };

    checkIP(); // IP 체크 함수 호출
  }, [location, navigate]); // navigate 추가

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/customer" className="sel">
                  상담 문의
                </a>
              </li>
              <li>
                <a href="/oneonone">1:1 문의</a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="subvisual">
          <div className="title">고객센터</div>
          <div className="text">아소비에 궁금한 점은 빠르게 해결하세요!</div>
          <div className="image">
            <img src="../custom-resources/img/sub_customer_bg.png" alt="" />
          </div>
        </div>
        <div className="breadcrumb">
          <div className="wrap">
            <div className="loca">
              <span>
                <img src="../custom-resources/img/icon_home.png" alt="" />
              </span>
              <span className="on">고객센터</span>
            </div>
            <div className="menu">
              <a href="/customer" className="on">
                상담문의
              </a>
              <a href="/oneonone">1:1 문의</a>
            </div>
          </div>
        </div>
        <div className="customer">
          <div className="sect customer01">
            <div className="wrap">
              <div className="tit">상담 문의</div>
              <div className="box init">
                <div className="top">
                  <div className="img">
                    <img src="../custom-resources/img/img_cuostmer_ico.png" alt="" />
                  </div>
                  <div className="con">
                    <p>아소비 대표번호</p>
                    <strong>1688 · 1993</strong>
                  </div>
                </div>
                <div className="bot">
                  <dl>
                    <dt>고객지원센터 운영시간 안내</dt>
                    <dd>
                      평일 - 09:30~12:00, 13:00~18:00 (토·일요일 및 법정
                      공휴일은 휴무입니다.)
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Customer;
